module.exports = __webpack_public_path__ + "static/phone-white-spanish-c81cd8c9be3e70c41d608369a9c587db.mp4";